export default {
	api: 'https://ust-testing2.beautitag.com/cso/api',
	loginTimeout: 86400
};
